import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
// Supabase's public publishable key is safe in a browser bundle. Never use a
// secret/service_role key here: access is enforced with database RLS policies.
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && key && !url.includes('tu-proyecto') && !key.includes('tu-clave'));
export const supabase = isSupabaseConfigured ? createClient(url!, key!) : null;
